export const routesPersonelBordro = [
  {
    path: "/personel_bordro",
    name: "personel_bordro",
    component: () => import("@/views/personel/personel_bordro/index.vue"),
    meta: {
      public: false,
      title: "personel.Personel Bordro",
      yetki: { k: [1014202] },
    },
  },
]
